import { Component, Inject } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
  MatDialogClose,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { UntypedFormControl } from '@angular/forms';
import { organizationDisplayFn } from 'src/app/app.types';
import { OrganizationModel } from 'src/app/api/models';
import {
  ShowInfoDialogComponent,
  ShowInfoItem,
} from 'src/app/cms/common/show-info-dialog/show-info-dialog.component';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { FormSelectComponent } from '../../../common/form-field/select.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { INFO_DIALOG_WIDTH } from 'src/app/utility/app.utils';

@Component({
  selector: 'qa-organization-for-course',
  templateUrl: './organization-for-course.component.html',
  styleUrls: ['./organization-for-course.component.scss'],
  imports: [
    MatIcon,
    MatDialogClose,
    CdkScrollable,
    MatDialogContent,
    FormSelectComponent,
    MatDialogActions,
    ButtonComponent,
    TranslateModule,
  ],
})
export class OrganizationForCourseComponent {
  organizationControl = new UntypedFormControl(null);
  organizationDisplayFn = organizationDisplayFn;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: OrganizationModel[],
    public dialogRef: MatDialogRef<OrganizationForCourseComponent>,
    private matDialog: MatDialog,
    private translator: TranslateService
  ) {}

  openDialog() {
    this.matDialog.open<ShowInfoDialogComponent, ShowInfoItem>(
      ShowInfoDialogComponent,
      {
        data: {
          infoData: this.translator.instant('courseMarket.organizationInfo'),
        },
        width: INFO_DIALOG_WIDTH,
        height: 'auto',
        panelClass: 'tooltip-modal',
      }
    );
  }

  selectCourse() {
    this.dialogRef.close(this.organizationControl.value);
  }
}
